<template>
    <div>
        <innerheader />
        <docsubmitted />
    </div>
</template>

<script>
// @ is an alias to /src
import innerheader from "@/components/innerheader/innerHeaderDIY.vue";
import docsubmitted from "@/components/uploaddocument/doc-submitted.vue";

export default {
  name:' uploaddocdiy',
  components: {
     innerheader,
     docsubmitted
  }
}
</script>

<style scoped lang="scss">
@import '~@/assets/scss/components/uploaddoc.scss';
</style>